import Vue from 'vue'

import App from './App.vue'
import router from './router'

import Vue2Filters from 'vue2-filters'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueChatScroll from 'vue-chat-scroll'
import VueMobileDetection from "vue-mobile-detection";

import './plugins/element.js'
import '@/plugins/Dayjs';
import 'element-ui/lib/theme-chalk/display.css';

import './scss/_variables.scss';


import store from './store'

import {
  Alert,
  Avatar,
  Card,
  Col,
  Collapse,
  CollapseItem,
  Dialog,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Option,
  Pagination,
  Radio,
  RadioButton,
  RadioGroup,
  Row,
  Select,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Timeline,
  TimelineItem,
  Upload,
  Image,
  Form,
  FormItem,
  
} from 'element-ui';

Vue.use(VueChatScroll)

Vue.config.productionTip = false
Vue.use(VueReCaptcha, {
  siteKey: '6LeXic4aAAAAAI5hklPw90y9fjgR3RAZnr0c20ac',
  loaderOptions: {
    useRecaptchaNet: true, 
    autoHideBadge: true
   
  }
});
Vue.use(VueMobileDetection);

Vue.use(Alert);
Vue.use(Avatar);
Vue.use(Card);
Vue.use(Col);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Dialog);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Loading.directive);
Vue.use(Option);
Vue.use(Pagination);
Vue.use(Radio);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Row);
Vue.use(Select);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(TabPane);
Vue.use(Tabs);
Vue.use(Upload);
Vue.use(Image);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
// Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;


var Vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: false
  },
  number: {
    format: '0',
    thousandsSeparator: '.',
    decimalSeparator: ','
  },
  bytes: {
    decimalDigits: 2
  },
  percent: {
    decimalDigits: 2,
    multiplier: 100,
    decimalSeparator: '.'
  },
  currency: {
    symbol: '$',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    showPlusSign: false
  },
  pluralize: {
    includeNumber: false
  },
  ordinal: {
    includeNumber: false
  }
}

Vue.use(Vue2Filters, Vue2FiltersConfig)
new Vue({
  store,
  router,
  render: h => h(App)
})
.$mount('#app')
